import "../styles/AquaFlowPromo.scss";
import aquaflow from "../assets/marketing/coletor.png";
import aquaflow_graph from "../assets/marketing/coletor_graph.png";

const Coletor = () => {
  return (
    <section className="aqua-flow-promo">
      <img src={aquaflow} alt="Aqua Flow Banner" className="top-image" />

      <div className="features">
        <div>
          <h3>ISOLAMENTO TÉRMICO COM VÁCUO</h3>
          <p>
            O isolamento a vácuo é ALTAMENTE EFICAZ na redução da transferência
            de calor, pois elimina os mecanismos de transferência de calor
            condutiva e convectiva. Isso torna-o ideal para aplicações onde a
            perda ou ganho de calor deve ser minimizado..
          </p>
        </div>
        <div>
          <h3>UM BANHO DE CONFORTO</h3>
          <p>
            O Coletor Solar Tubo a Vácuo de Baixa Pressão é responsável por
            elevar a temperatura da água a um nível agradável para o banho,
            tornando possível desfrutar de um momento relaxante mesmo em
            temperaturas externas baixas.
          </p>
        </div>
        <div>
          <h3>VIDRO ESPECIAL</h3>
          <p>
            O vidro de borossilicato é um tipo de vidro com várias vantagens em
            relação a outros tipos de vidro, como o vidro comum ou o vidro
            temperado.
          </p>
        </div>
      </div>

      <div className="button-wrapper">
        <a
          href={`https://wa.me/555391425203?text=Olá%2C+tenho+interesse+em+seus+serviços+de+${"coletor+a+vácuo"}.`}
          target="_blank"
          style={{ color: "inherit" }}
        >
          <button>Solicite seu orçamento</button>
        </a>
      </div>

      <img
        src={aquaflow_graph}
        alt="Gráfico de desempenho"
        className="bottom-image"
      />
    </section>
  );
};

export default Coletor;
